import {
  initBlockServices,
  initBlockClubsAgreements,
  initBlockClubsCollaboration,
  initBlockClubsProcess,
  initBlockClubsTraining,
  initCardBio,
  initCenteredScalingNavigationBar,
  initDirectionalListHover,
  initFooterParallax,
  initGalleryScroll,
  initHighlightText,
  initImageContact,
  initMomentumBasedHover,
  initParallax,
  initPinnedInstalaciones,
  initScrollMarquee,
  initSplitHover,
  initStickyFeatures,
  initTextBlur,
  initTextClip,
} from "./gsap";

import { initCursor } from "./cursor"; // 👈 importa tu cursor
import { initLenis } from "./initLenis";
import { initBarbaTransitions } from "./pageTransition";

document.addEventListener("DOMContentLoaded", () => {
  const lenis = initLenis();

  // ✅ Cursor FUERA de Barba (solo se inicia 1 vez)
  initCursor();

  initBarbaTransitions({
    lenis,
    common: [
      initGalleryScroll,
      initMomentumBasedHover,
      initCenteredScalingNavigationBar,
      initHighlightText,
      initSplitHover,
      initParallax,
      initStickyFeatures,
      initFooterParallax,
      initTextClip,
      initTextBlur,
      initPinnedInstalaciones,
      initDirectionalListHover,
      initScrollMarquee,
      initBlockServices,
      initBlockClubsAgreements,
      initBlockClubsCollaboration,
      initBlockClubsProcess,
      initBlockClubsTraining,
      initCardBio,
      initImageContact,
    ],
    byNs: { home: [] },
    initOnLoad: true,
  });
});
